<script lang="ts">
	import { trimString } from '$lib/util/util';
	import { smartContractWalletAddress, smartWalletName } from '../store';

	let isContentEditable = false;
	let smartWalletNameInput: string = $smartWalletName;

	export let size = 'sm';

	const toggleEditWalletName = () => {
		isContentEditable = !isContentEditable;
	};

	const smartWalletNameChanged = () => {
		$smartWalletName = smartWalletNameInput;
		window.localStorage.setItem(`walletName-${$smartContractWalletAddress}`, smartWalletNameInput);
	};
</script>

<div class="grid grid-cols-2">
	{#if isContentEditable}
		<div class={`text-fx-grey-300 text-${size}`}>New wallet name</div>
	{:else}
		<div class={`text-fx-grey-300 text-${size}`}>Wallet name</div>
	{/if}
	<div class={`text-${size} text-fx-gradient-14 text-right flex gap-1.5`}>
		<div class="grow" />

		<div class="flex items-center gap-1">
			{#if isContentEditable}
				<input
					autocomplete="off"
					autocorrect="off"
					minlength="1"
					maxlength="30"
					spellcheck="false"
					bind:value={smartWalletNameInput}
					on:input={smartWalletNameChanged}
					on:blur={toggleEditWalletName}
					type="string"
					placeholder="Wallet name"
					class="bg-transparent text-fx-white outline-none w-28 text-right"
				/>
			{:else}
				<div>
					{trimString($smartWalletName, 15)}
				</div>
				<button on:click={toggleEditWalletName} on:keydown={toggleEditWalletName}>
					<img src={'edit.svg'} loading="lazy" alt="help" class="w-5 h-5" />
				</button>
			{/if}
		</div>
	</div>
</div>
